// @flow
import modalActions from '../../actions/modals';
import {
    SEARCH_MODAL,
    FILTERS_MODAL,
    DATE_MODAL,
    GUEST_MODAL,
    FILTERS_DATES_MODAL,
    FILTERS_GUEST_MODAL
} from '../../actions/modals';
import type {Store} from '../../reducers';
import {media} from '../../utils/breakpoints';

// TODO Add flow type to `payload` when redux-little-router upgraded to ^15.1.0
const modals = (store: Store, action: {type: string, payload: Object}) => {
    const {viewport, modals: modalState} = store.getState();
    const isMobile = !media(viewport.breakpoint, {minWidth: 'SM_MIN'});
    const {query} = action.payload;

    if (isMobile) {
        [
            SEARCH_MODAL,
            FILTERS_MODAL,
            DATE_MODAL,
            GUEST_MODAL,
            FILTERS_DATES_MODAL,
            FILTERS_GUEST_MODAL
        ].forEach((type) => {
            if (query.modal && query.modal.includes(type)) {
                store.dispatch(modalActions.toggle(type, true));
            } else if (modalState[type].isOpen) {
                store.dispatch(modalActions.toggle(type, false));
            }
        });
    }
};

export default modals;
